import PageContent from './components/PageContent'

const PublicationDeadlines = () => (
  <PageContent />
)

export default PublicationDeadlines
